import React, { Component } from 'react';
import './nav-bar.css';
import { FaBriefcase, FaCode, FaGithub, FaLinkedin, FaUser } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

export type NavSection = 'profile' | 'work' | 'career';

interface NavBarProps {
    activeSection: NavSection;
}

export class NavBar extends Component<NavBarProps> {
    render() {
        const { activeSection } = this.props;

        return (
            <header className="site-header">
                <div className="navbar">
                    <a className="navbar-brand" href="#profile" aria-label="Ahmed Magdy profile">
                        <span className="navbar-brand-mark" aria-hidden="true">AM</span>
                        <span className="navbar-brand-name">Ahmed Magdy</span>
                    </a>
                    <nav className="navbar-sections" aria-label="Primary navigation">
                        <a href="#profile" aria-current={activeSection === 'profile' ? 'location' : undefined}>
                            <FaUser aria-hidden="true" /> Profile
                        </a>
                        <a href="#work" aria-current={activeSection === 'work' ? 'location' : undefined}>
                            <FaCode aria-hidden="true" /> Work
                        </a>
                        <a href="#career" aria-current={activeSection === 'career' ? 'location' : undefined}>
                            <FaBriefcase aria-hidden="true" /> Career
                        </a>
                    </nav>
                    <nav className="navbar-social" aria-label="Social links">
                        <a
                            href="https://www.linkedin.com/in/ahmedmagdy"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="LinkedIn"
                            title="LinkedIn"
                        >
                            <FaLinkedin aria-hidden="true" />
                        </a>
                        <a
                            href="https://github.com/amgdy"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="GitHub"
                            title="GitHub"
                        >
                            <FaGithub aria-hidden="true" />
                        </a>
                        <a
                            href="https://x.com/amgdy"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="X"
                            title="X"
                        >
                            <FaXTwitter aria-hidden="true" />
                        </a>
                    </nav>
                </div>
            </header>
        );
    }
}